import type { SxProps, Theme } from '@mui/material';

export const whiteSelectSx: SxProps<Theme> = {
  backgroundColor: '#ffffff',
  '& .MuiOutlinedInput-root': { backgroundColor: '#ffffff' },
  '& .MuiSelect-select': { backgroundColor: '#ffffff' },
};

export const whiteSelectMenuProps = {
  PaperProps: {
    sx: { backgroundColor: '#ffffff' } as SxProps<Theme>,
  },
};
